import { bundledLanguagesBase, bundledThemes } from "shiki"

export const freeTools = [
    {
        title: 'Image generators',
        items: [
            {
                title: 'QR Code Generator',
                icon: "mdi:qrcode-scan",
                href: '/free-tools/qr-code-generator/',
                description: 'Provide a link for a free downloadable QR Code.'
            },
            {
                title: 'Emoji Favicon Generator',
                icon: "fluent:emoji-48-filled",
                href: '/free-tools/favicon-generator/from-emoji/',
                description: 'Pick an emojii and download it as favicon.'
            }
        ]
    },
    {
        title: 'Code generators',
        items: [
            {
                title: 'Codeblock Highlight',
                icon: "heroicons-outline:code",
                href: '/free-tools/codeblock-highlight/',
                description: `Edit beatiful codeblock in ${Object.keys(bundledLanguagesBase).length} languages, ${Object.keys(bundledThemes).length} and copy paste them.`
            }
        ]
    }
] as const